import { Form, FormikProvider, useFormik } from "formik";
import React, { useEffect } from "react";
import { Button } from "styled";
import InputField from "components/formik/InputField";
import { createDocument, updateDocumentByID } from "apis/customApiHandler";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import SelectField from "components/formik/SelectField";
import Modal from "components/Modal";

const CustomAddPage = ({
  data,
  setData,
  url,
  queryKey,
  handleClick,
  yupValidationSchema,
  onCancel,
  inputFields,
  pageTitle,
  action,
  updateId,
  disabled
}) => {
  const { mutateAsync } = useMutation((data) =>
    action === "update"
      ? updateDocumentByID(url, updateId, data)
      : createDocument(url, data)
  );
  const queryClient = useQueryClient();

  const formik = useFormik({
    initialValues: data,
    onSubmit: async (values) => {
      let filterSelectInputs = inputFields?.filter(
        (input) => input.type === "select"
      );

      let filterSelectInputsValues = filterSelectInputs?.map((input) => {
        return values[input.name];
      });
      let finalInputs = { ...values };
      filterSelectInputsValues?.forEach((input, index) => {
        finalInputs[filterSelectInputs[index].name] = filterSelectInputs[index]
          .multiple
          ? input.map((val) => val.value)
          : input.value;
      });

      await mutateAsync(finalInputs, {
        onSuccess: (data) => {
          queryClient.invalidateQueries(queryKey);
          if (data && data.message) {
            toast.success(data.message);
            handleClick();
          }
        },
        onError: (err) => {
          toast.error(
            err.response.data.error ||
              err.response.data.message ||
              err.message ||
              "Something went wrong"
          );
        },
      });
    },

    validationSchema: yupValidationSchema || undefined,
    validate: (values) => {
      let errors = {};
      inputFields.forEach((field) => {
        if (field.required && !values[field.name]) {
          errors[field.name] = "Required";
        }
      });
      return errors;
    },
  });

  useEffect(() => {
    if (setData) {
      setData(formik.values);
    }
  }, [formik.values, setData]);

  // useEffect(()=>{
  //   console.log({data})
  //   if(!setData){
  //     formik.setValues({...data})
  //   }
  // },[data])

  // console.log(formik.values)

  return (
    <Modal
      handleClick={handleClick}
      title={pageTitle}
      className="max-w-2xl min-h-fit "
    >
      <FormikProvider value={formik}>
        <Form className="px-5 py-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          {inputFields.map((field) => {
            switch (field.type) {
              case "select":
                return (
                  <SelectField
                    formik={formik}
                    key={field.name}
                    name={field.name}
                    label={field.label}
                    options={field.options}
                    required={field.required}
                    multiple={field.multiple}
                  />
                );
              case "file":
                return (
                  <div>
                    {field.url && (
                      <img src={field.url} className="w-16 h-16" alt="" />
                    )}
                    <InputField
                      formik={formik}
                      key={field.name}
                      name={field.name}
                      label={field.label}
                      type={field.type}
                      required={field.required}
                    />
                  </div>
                );

              default:
                return (
                  <InputField
                    {...field}
                    key={field.name}
                    name={field.name}
                    label={field.label}
                    type={field.type}
                    placeholder={field.placeholder}
                    required={field.required}
                    disabled={field.disabled}
                  />
                );
            }
          })}
          {inputFields.length % 2 === 0 ? <div /> : null}
          <div className="flex items-end justify-end gap-4 mt-6">
            <Button
              type="button"
              onClick={onCancel ? onCancel : handleClick}
              bgSecondary
            >
              <span>Cancel</span>
            </Button>
            <Button type="submit" disabled={disabled}>
              <span>Save</span>
            </Button>
          </div>
        </Form>
      </FormikProvider>
    </Modal>
  );
};

export default CustomAddPage;
